module.exports = __webpack_public_path__ + "static/media/popup.554dbc57.jpg";